import { ReactElement, useState, useEffect } from "react";
import "./AboutUs.css";
import GeneralLayoutWithDots from "./components/GeneralLayoutWithDots";
import {IObjectives } from "../../Services/Objectives";
import { axios } from '../..';


export default function Objectives(): ReactElement {
  const [objectives, setObjectives] = useState<IObjectives | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchObjectives = async () => {
      try {
        setLoading(true);
        setError(null);
        const response = await axios.Get("/objectives");
        setObjectives(response.data[0]);
      } catch (error) {
        console.error("Error fetching objectives:", error);
        setError("Failed to load objectives data");
      } finally {
        setLoading(false);
      }
    };
    fetchObjectives();
  }, []);

  return (
      <div className="w-full">

        <GeneralLayoutWithDots
          subTitle="More About WSG"
          CurrentPage="Objectives"
        >
          <>
            {/* Chair's Objectives Content Section */}
            <div className="about-us-page-content py-4 xs:py-5 sm:py-6 md:py-8">

              {/* Loading State */}
              {loading && (
                <div className="text-left py-8 xs:py-10 sm:py-12">
                  <div className="text-base xs:text-lg text-gray-600">Loading objectives...</div>
                </div>
              )}

              {/* Error State */}
              {error && (
                <div className="text-left py-8 xs:py-10 sm:py-12">
                  <div className="text-base xs:text-lg text-red-600 mb-4">{error}</div>
                  <button
                    onClick={() => window.location.reload()}
                    className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
                  >
                    Retry
                  </button>
                </div>
              )}

              {/* Main Content Grid */}
              {objectives && !loading && !error && (
                <div className="grid grid-cols-1 lg:grid-cols-4 gap-4 xs:gap-5 sm:gap-6 md:gap-8">
                
                {/* Left Column - Dynamic Content from Database */}
                <div className="lg:col-span-3">
                  <div 
                    className="objectives-content"
                    dangerouslySetInnerHTML={{ __html: objectives.Objectives }}
                  />
                </div>

                {/* Right Column - Sidebar */}
                <div className="lg:col-span-1">
                  
                  {/* WSG Mission */}
                  <div className="w-full mb-4 xs:mb-5 sm:mb-6 shadow-md">
                    <div className="bg-primary text-white">
                      <p className="sidebar-box-title text-left pr-2 xs:pr-3 sm:pr-[10px] pl-4 xs:pl-6 sm:pl-8 md:pl-[40px] py-3 xs:py-4 sm:py-[18px]">WSG MISSION</p>
                    </div>
                    <div className="p-4 xs:p-6 sm:p-8 md:p-10" style={{ backgroundColor: '#F6F6F6' }}>
                      <p className="sidebar-box-text text-left">
                        WSG is the most prominent global network of independent firms that provides an exclusive setting and platform to connect its members to the most elite legal firms with cross industry access to select investment banking and accounting firms.
                      </p>
                      <p className="sidebar-box-text mt-3 text-left">
                        Through this network, WSG delivers global expertise powered by seamless collaboration and provides the highest quality and value for clients.
                      </p>
                    </div>
                  </div>

                  {/* WSG Vision */}
                  <div className="w-full mb-4 xs:mb-5 sm:mb-6 shadow-md">
                    <div className="bg-primary text-white">
                      <p className="sidebar-box-title text-left pr-2 xs:pr-3 sm:pr-[10px] pl-4 xs:pl-6 sm:pl-8 md:pl-[40px] py-3 xs:py-4 sm:py-[18px]">WSG VISION</p>
                    </div>
                    <div className="px-4 xs:px-5 sm:px-6 py-4 xs:py-5 sm:py-6" style={{ backgroundColor: '#F6F6F6' }}>
                      <p className="sidebar-box-text text-left">
                        WSG enables seamless collaboration, association, and continual innovation across a global network of prominent and independent professional service firms providing legal and cross industry expertise for valuable client solutions.
                      </p>
                    </div>
                  </div>

                  {/* WSG Governance */}
                  <div className="w-full mb-4 xs:mb-5 sm:mb-6 shadow-md">
                    <div className="bg-primary text-white">
                      <p className="sidebar-box-title text-left pr-2 xs:pr-3 sm:pr-[10px] pl-4 xs:pl-6 sm:pl-8 md:pl-[40px] py-3 xs:py-4 sm:py-[18px]">WSG GOVERNANCE</p>
                    </div>
                    <div className="px-4 xs:px-5 sm:px-6 py-4 xs:py-5 sm:py-6" style={{ backgroundColor: '#F6F6F6' }}>
                      <p className="sidebar-box-text text-left">
                        WSG is governed by Bylaws which provide the framework needed for WSG operations and governance.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              )}
            </div>
          </>
        </GeneralLayoutWithDots>
      </div>
  );
}
